import angular from "angular";
import { ITemplateOptions, IFormOptionsAPI, IFieldObject } from "AngularFormly";
import { PatchObject, Record } from "../../../../server/crud";
import { IApiResponse, IQuery, IQueryResponse } from "../../../../server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../server/serverUtility";

export interface RecordSelectAsyncTemplateOptions extends ITemplateOptions {
  queryUrl: string;
  queryBuilder?: (search: string) => IQuery;
  getDefaultItem: (model: any) => { Id: number; Name: string } | undefined;
  useLegacyQuery?: boolean;
}

interface RecordSelectAsyncControllerScope extends angular.IScope {
  to: RecordSelectAsyncTemplateOptions;
  model: Record;
  currentItems: Record[];
  valueProp: string;
  labelProp: string;
  formState: any;
  onSelect: (selected: any) => void;
  query: (search: string) => void;
  selectedItem: Record | undefined;
}

export class RecordSelectAsyncController {
  static $inject = ["$scope", ServerUtilityName];
  defaultQueryPromise!: angular.IPromise<Record[]>;
  private readonly queryBuilder: (search: string) => IQuery;

  get templateOptions(): RecordSelectAsyncTemplateOptions {
    return this.$scope.to;
  }

  constructor(
    private readonly $scope: RecordSelectAsyncControllerScope,
    private readonly serverUtility: ServerUtility
  ) {
    $scope.currentItems = [];
    $scope.valueProp ??= "Id";
    $scope.labelProp ??= "Name";
    $scope.onSelect = (selected) => this.onSelect(selected);
    $scope.query = (search) => this.query(search);
    this.queryBuilder =
      this.templateOptions.queryBuilder ??
      RecordSelectAsyncController.defaultQueryBuilder;
    //this isn't called by angular for some reason
    this.$onInit();
  }
  $onInit() {
    const initialItem = this.$scope.model
      ? this.templateOptions.getDefaultItem(this.$scope.model)
      : undefined;
    this.$scope.selectedItem = initialItem;

    if (initialItem === undefined) {
      return;
    }
    this.$scope.currentItems = [initialItem];
    this.defaultQueryPromise = this.getResultsFromServer(this.queryBuilder(""));
  }

  onSelect(selected: any) {
    this.$scope.selectedItem = selected;
  }

  query(search: string) {
    if (!search) {
      this.defaultQueryPromise.then((r) => (this.$scope.currentItems = r));
      return;
    }
    const query = this.queryBuilder(search);
    this.getResultsFromServer(query).then(
      (r) => (this.$scope.currentItems = r)
    );
  }

  private getResultsFromServer(query: IQuery): angular.IPromise<Record[]> {
    query.Skip = 0;
    query.Take = 10;
    query.OrderBy = this.$scope.labelProp;

    const queryUrl = this.templateOptions.queryUrl;

    return this.templateOptions.useLegacyQuery
      ? this.serverUtility
          .queryLegacy<Record>({ url: queryUrl, query })
          .then((r) => r.Results)
      : this.serverUtility
          .query<Record>({ url: queryUrl, query })
          .then((r) => r.Results);
  }

  private static defaultQueryBuilder(search: string): IQuery {
    return {
      NameContains: search,
    };
  }
}
